import { render, staticRenderFns } from "./default-error.vue?vue&type=template&id=5ff3b5e9&scoped=true"
import script from "./default-error.vue?vue&type=script&lang=js"
export * from "./default-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3b5e9",
  null
  
)

export default component.exports